import { render, staticRenderFns } from "./noticePreviewComp.vue?vue&type=template&id=eb691fba&scoped=true"
import script from "./noticePreviewComp.vue?vue&type=script&lang=js"
export * from "./noticePreviewComp.vue?vue&type=script&lang=js"
import style0 from "./noticePreviewComp.vue?vue&type=style&index=0&id=eb691fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb691fba",
  null
  
)

export default component.exports